import { c as _c } from "react-compiler-runtime";
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorLoadingAsync = t0 => {
  "use memo";

  const $ = _c(5);
  const {
    retry
  } = t0;
  let t1;
  if ($[0] !== retry) {
    t1 = () => retry();
    $[0] = retry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.panelLoad.error"
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest",
      children: /*#__PURE__*/_jsx(Link, {
        onClick: t1,
        children: t2
      })
    });
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};